<template>
</template>
<script>
  import { seoData } from '../../../../static/website/js/SEO.js'
  export default {
    name: 'Home',
    data () {
    return {

    	pageTitle: seoData[0][this.$route.path.split('/')[1]].META_TITLE,
    	pageDescription: seoData[0][this.$route.path.split('/')[1]].META_DESCRIPTION,
    	pageKeywords: seoData[0][this.$route.path.split('/')[1]].META_KEYWORDS
        }
    },
    metaInfo () {
      return {
        title: this.pageTitle,
        meta: [
        	{ charset: 'utf-8' },
        	{ name: 'description', content: this.pageDescription },
        	{ name: 'keywords', content: this.pageKeywords },
			{
				'vmid': 'description',
				'content': this.pageDescription
			},
			{
				'vmid': 'keywords',
				'content': this.pageKeywords
			}
			
		]
		
      }
    },
    components: {

    },
    created(){
        $("#myNavbar").removeClass("in")
    },
    mounted() {
        
        $("#myNavbar").removeClass("in")

    	window.scrollTo(0, 0)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/website/shared/SEO.vue